/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ImagingMachineDto } from './ImagingMachineDto';
import {
    instanceOfImagingMachineDto,
    ImagingMachineDtoFromJSON,
    ImagingMachineDtoFromJSONTyped,
    ImagingMachineDtoToJSON,
} from './ImagingMachineDto';
import type { LinearAcceleratorDto } from './LinearAcceleratorDto';
import {
    instanceOfLinearAcceleratorDto,
    LinearAcceleratorDtoFromJSON,
    LinearAcceleratorDtoFromJSONTyped,
    LinearAcceleratorDtoToJSON,
} from './LinearAcceleratorDto';
import type { OtherMedicalSystemDto } from './OtherMedicalSystemDto';
import {
    instanceOfOtherMedicalSystemDto,
    OtherMedicalSystemDtoFromJSON,
    OtherMedicalSystemDtoFromJSONTyped,
    OtherMedicalSystemDtoToJSON,
} from './OtherMedicalSystemDto';
import type { OtherMvTherapyMachineDto } from './OtherMvTherapyMachineDto';
import {
    instanceOfOtherMvTherapyMachineDto,
    OtherMvTherapyMachineDtoFromJSON,
    OtherMvTherapyMachineDtoFromJSONTyped,
    OtherMvTherapyMachineDtoToJSON,
} from './OtherMvTherapyMachineDto';
import type { OtherTreatmentMachineDto } from './OtherTreatmentMachineDto';
import {
    instanceOfOtherTreatmentMachineDto,
    OtherTreatmentMachineDtoFromJSON,
    OtherTreatmentMachineDtoFromJSONTyped,
    OtherTreatmentMachineDtoToJSON,
} from './OtherTreatmentMachineDto';
import type { SoftwareDto } from './SoftwareDto';
import {
    instanceOfSoftwareDto,
    SoftwareDtoFromJSON,
    SoftwareDtoFromJSONTyped,
    SoftwareDtoToJSON,
} from './SoftwareDto';

/**
 * @type MedicalSystemRtSystemDto
 * 
 * @export
 */
export type MedicalSystemRtSystemDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.ImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & ImagingMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared' } & LinearAcceleratorDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared' } & OtherMedicalSystemDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & OtherMvTherapyMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } & OtherTreatmentMachineDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.SoftwareDto, Ptw.Ptw100.AppZero.Application.Shared' } & SoftwareDto;


export function MedicalSystemRtSystemDtoFromJSON(json: any): MedicalSystemRtSystemDto {
    return MedicalSystemRtSystemDtoFromJSONTyped(json, false);
}

export function MedicalSystemRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemRtSystemDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.ImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, ImagingMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.ImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, LinearAcceleratorDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, OtherMedicalSystemDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, OtherMvTherapyMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, OtherTreatmentMachineDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.SoftwareDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, SoftwareDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.SoftwareDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of MedicalSystemRtSystemDto exists with '$type=${json['$type']}'`);
    }
}

export function MedicalSystemRtSystemDtoToJSON(value?: MedicalSystemRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.ImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ImagingMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return LinearAcceleratorDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMedicalSystemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return OtherMedicalSystemDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return OtherMvTherapyMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared':
            return OtherTreatmentMachineDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.SoftwareDto, Ptw.Ptw100.AppZero.Application.Shared':
            return SoftwareDtoToJSON(value);
        default:
            throw new Error(`No variant of MedicalSystemRtSystemDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the MedicalSystemRtSystemDto interface.
 */
export function instanceOfMedicalSystemRtSystemDto(value: any): value is MedicalSystemRtSystemDto {
    if (instanceOfImagingMachineDto(value)) return true;
    if (instanceOfLinearAcceleratorDto(value)) return true;
    if (instanceOfOtherMedicalSystemDto(value)) return true;
    if (instanceOfOtherMvTherapyMachineDto(value)) return true;
    if (instanceOfOtherTreatmentMachineDto(value)) return true;
    if (instanceOfSoftwareDto(value)) return true;
    return false;
}

